class FieldMapping {
    fieldMap = {
        firstname: 'first_name',
        lastname: 'last_name',
        email: 'email',
        phonenumber: 'phone_number',
        profilePicture: 'profile_picture',
        referralCode: 'referral_code',
        credits: 'credits',
        country: 'country',
        city: 'city',
        verified: 'verified',
        travelMeaning: 'travel_meaning',
        isStaff: 'is_staff',
        groups: 'groups',
        localLeaderTrips: 'local_leader_trips',
    };

    reverseFieldMap = Object.keys(this.fieldMap).reduce((obj, key) => {
        obj[this.fieldMap[key]] = key;
        return obj;
    }, {});
}

export class User {
    firstname: string;
    lastname: string;
    email: string;
    phonenumber: string;
    profilePicture: string;
    referralCode: string;
    credits: number;
    country: string;
    city: string;
    verified: boolean;
    travelMeaning: string;
    isStaff: boolean;
    groups: string[];
    localLeaderTrips: string[];

    private static fieldMap = new FieldMapping().fieldMap;

    private static reverseFieldMap = new FieldMapping().reverseFieldMap;

    public static mapField(field: string) {
        return this.fieldMap[field];
    }
    public static reverseMapField(field: string) {
        return this.reverseFieldMap[field];
    }

    deserialize(input: any): this {
        for (let [key, value] of Object.entries(input)) {
            this[User.reverseMapField(key)] = value;
        }
        return this;
    }

    serialize() {
        return {
            first_name: this.firstname,
            last_name: this.lastname,
            email: this.email,
            phone_number: this.phonenumber,
            profile_picture: this.profilePicture,
        };
    }
}
